// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"64":"fa710bf7","181":"fc612060","193":"f4bd1e78","295":"197fa8f7","683":"33acc407","965":"eaf542aa"}[chunkId] + ".css";
};